import loadCondition from '@/router/base-info/order-properties/load-condition'

export default {
  Add: 'Add',
  Addresses: 'Addresses',
  AddUser: 'Add User',
  ActiveShipment: 'Active Order',
  BaseInfo: 'Base Information',
  CurrentLoads: 'Current Loads',
  Account: 'Account',
  Another: 'Another',
  AppVersion: 'App Version',
  AssignedToDriver: 'Assigned To Driver',
  CustomerApprovedRequest: 'Customer Approved Request',
  CompanyApprovedRequest: 'Courier Approved Request',
  Books: 'Books',
  Bank: 'Bank',
  BankAccount: 'bank account',
  ChangePassword: 'Change password',
  CarLoad: 'Car Load',
  Category: 'Category',
  Countrys: 'Countrys',
  County: 'County',
  Colors: 'Colors',
  Comments: 'Comments',
  CouponTypes: 'Coupon Types',
  Coupones: 'Coupones',
  CompanyManage: 'Courier Manage',
  CompanyExtraCar: 'Courier Extra Car',
  CompanyExtraItem: 'Courier Extra Item',
  CompanyExtraEmployee: 'Courier Extra Employee',
  CompanyExtra: 'Courier Extra',
  CompanyExtraTariff: 'Courier Tariff',
  Citys: 'Citys',
  CarLiveLocation: 'Car Live Location',
  CompanyController: 'Courier Controller',
  CreateCompany: 'Create New Courier',
  Contacts: 'Contacts',
  CarManage: 'Car Manage',
  CarOptiones: 'Car Optiones',
  CarModel: 'Car Model',
  CarController: 'Car Controller',
  CarFeature: 'Car Feature',
  CarBrand: 'Car Brand',
  Calendar: 'Calendar',
  CalendarTrafficPlan: 'Calendar Traffic Plan',
  Campaign: 'Campaign',
  Crm: 'Crm',
  CompanyExtraTrafficPlan: 'Courier Extra Traffic Plan',
  Currency: 'Currency',
  Dashboard: 'Dashboard',
  Details: 'Details',
  DriverTraining: 'DriverTraining',
  Driver: 'Driver',
  Decision: 'Decision',
  Department: 'Department',
  Discount: 'Discount',
  EditCargo: 'Edit Cargo',
  Employee: 'Employee',
  Edit: 'Edit',
  EditOrder: 'Edit Order',
  Expectation: 'Expectation',
  Email: 'Email',
  Feedback: 'Feedback',
  Financial: 'Financial',
  FeaturController: 'Featur Controller',
  FeedbackCriterion: 'Feedback Criterion',
  GiftCardTypes: 'Gift card types',
  GiftCards: 'Gift cards',
  GenarateCoupones: 'Genarate Coupones',
  GenerateGiftCard: 'Generate GiftCard',
  Home: 'Home',
  Holding: 'Holding',
  Holiday: 'Holiday',
  Index: 'Index',
  Item: 'Item',
  Licenses: 'Licenses',
  branch: 'branch',
  Load: 'Load',
  Menu: 'Menu',
  Media: 'Media',
  Measurement: 'Measurement',
  Messenger: 'Messenger',
  Notification: 'Notification',
  Pages: 'Pages',
  Profile: 'Profile',
  Payment: 'payment',
  Packages: 'Packages',
  Package: 'Package',
  Past: 'Finishd',
  Permission: 'Permission',
  Policy: 'Policy',
  Promotions: 'Promotions',
  Read: 'Read',
  Realm: 'Realm',
  Role: 'Role',
  RegisterOrder: 'Register order',
  Respond: 'Respond',
  ReportMessenger: 'Report Messenger',
  Transport: 'transport',
  Info: 'Info',
  ItemGroup: 'Item Group',
  ItemController: 'Item Controller',
  ItemFeature: 'Item Feature',
  Organization: 'Organization',
  ShipmentDetails: 'Order Details',
  Size: 'Size',
  Sections: 'Book sections',
  shipment: 'Order',
  ShipmentreportsAll: 'Order Reports',
  pointsReport: 'origin and destinations',
  Security: 'Security',
  Settings: 'Settings',
  Session: 'Session',
  Subject: 'Subject',
  SubCategory: 'SubCategory',
  SpeedDrivers: 'Speed Drivers',
  Sms: 'Sms',
  Statistics: 'Statistics',
  Ticket: 'Ticket',
  TicketMessage: 'Ticket Message',
  Tariff: 'Tariff',
  UserSession: 'User session',
  Users: 'Users',
  UrlShortened: 'Url Shortened',
  Url: 'Url',
  UnitController: 'Unit Controller',
  UserController: 'User Controller',
  UserGroup: 'User Group',
  Variable: 'Variable',
  Widgets: 'Widgets',
  widgets: 'Widgets',
  WebServices: 'WebServices',
  Zons: 'Zons',
  LogReporter: 'Log Reporter',
  CarReportLogs: 'Car Tariff Report Logs',
  ItemReportLogs: 'Item Tariff Report Logs',
  ExtraReportLogs: 'Extra Tariff Report Logs',
  EmployeeReportLogs: 'Employee Tariff Report Logs',
  AuctionReportLogs: 'Auction Report Logs',
  TrafficPlanReportLogs: 'Traffic Plan Report Logs',
  CloneOrder: 'Clone Order',
  Furniture: 'Furniture',
  Cargo: 'Cargo',
  License: 'License',
  Operator: 'Operator',
  Appropriation: 'Appropriation',
  Live: 'Live',
  Trajectory: 'Trajectory',
  CurrentTrajectory: 'Current Trajectory',
  TariffAuction: 'Auction',
  Location: 'Location',
  System: 'System',
  CMS: 'CMS',
  Faq: 'Faq',
  Reasons: 'Reasons',
  Cancel: 'Cancel',
  ShipmentTemplate: 'Order template',
  ShipmentDraft: 'Order draft',

  //refactor
  add: 'Add',
  edit: 'Edit',
  home: 'Home',
  baseInfo: 'Base Information',
  carModel: 'Car Model',
  carLoad: 'Car Load',
  carFeature: 'Car Feature',
  carBrand: 'Car Brand',
  employee: 'Employee',
  itemGroup: 'Item Group',
  item: 'Item',
  itemController: 'Item Controller',
  itemFeature: 'Item Feature',
  load: 'Load',
  packages: 'Packages',
  carton: 'Carton',
  cancel: 'Cancel',
  reasons: 'Reasons',
  organization: 'Organization',
  feedback: 'Feedback',
  feedbackCriterion: 'Feedback Criterion',
  feedbackPointCriterion: 'Feedback Point Criterion',
  referrerType: 'Referrer type',
  club: 'Club',
  userGroup: 'User group',
  userLevel: 'User level',
  department: 'Department',
  category: 'Category',
  subCategory: 'SubCategory',
  media: 'Media',
  subject: 'Subject',
  crm: 'Crm',
  bank: 'Bank',
  bankAccount: 'Bank account',
  policy: 'Policy',
  financial: 'Financial',
  courierEquipment: 'Courier equipment',
  equipment: 'Equipment',
  courier: 'Courier',
  expertise: 'Expertise',
  courierExpertise: 'Courier expertise',
  educationLevel: 'Education level',
  licenseType: 'LicenseType',
  courierLicenseType: 'courierLicenseType',
  courierLicenseCategory: 'courierLicenseCategory',
  users: 'Users',
  contract: 'Contract',
  contractCategory: 'Contract category',
  faqCategory: 'Faq category',
  themeCategory: 'Theme category',
  theme: 'Theme',
  postCategory: 'Post category',
  cms: 'CMS',
  questionnaire: 'Questionnaire',
  questionCategory: 'Question category',
  question: 'Question',
  answer: 'Answer',
  survey: 'Survey',
  geoLocations: 'Geo locations',
  country: 'Country',
  province: 'Province',
  county: 'County',
  city: 'City',
  district: 'District',
  trafficPlan: 'Traffic plan',
  unit: 'Unit',
  measurement: 'Measurement',
  currency: 'Currency',
  size: 'Size',
  color: 'Color',
  featurController: 'Featur Controller',
  holiday: 'Holiday',
  calendar: 'Calendar',
  usersReport: 'Users report',
  customersReport: 'Customers report',
  customers: 'Customers',
  adminsReport: 'Admins report',
  admins: 'Admins',
  details: 'Details',
  approve: 'Approve',
  security: 'Security',
  realm: 'Realm',
  role: 'Role',
  userSession: 'User session',
  session: 'Session',
  operator: 'Operator',
  driver: 'Driver',
  live: 'Live',
  trajectory: 'Trajectory',
  address: 'Address',
  company: 'Courier',
  holding: 'Holding',
  licenses: 'Licenses',
  campaign: 'Campaign',
  discount: 'Discount',
  couponTypes: 'Coupon Types',
  giftCardTypes: 'Gift card types',
  giftCards: 'Gift cards',
  genarateCoupons: 'Genarate Coupons',
  generateGiftCard: 'Generate GiftCard',
  promotions: 'Promotions',
  coupons: 'Coupons',
  reports: 'Reports',
  undefinedTariffs: 'Undefined tariffs',
  car: 'Car',
  auction: 'Auction',
  specialTariff: 'Special tariff',
  log: 'Log',
  tariffs: 'Tariffs',
  chart: 'Chart',
  ticketMessage_: 'Ticket message',
  educationLevel: 'Education level',
  payment: 'Payment',
  bankPayment: 'Bank payment',
  authorityLimit: 'Authority limit',
  loads: 'Loads',
  area: 'Area',
  timeSheet: 'Time sheet',
  trafficPlanTemplate: 'Traffic plan template',
  courierPlanTemplate: 'Courier plan template',
  dictionary: 'dictionary',
  landingPage: 'LandingPage',
  postage: 'Postage',
  miss: 'Miss',
  messages: 'Messages',
  sent: 'Sent',
  dictionaryConflict: 'Dictionary conflict',
  conflictWithReferenceSystem: 'Conflict with reference system',
  conflictWithExternalSystem: 'Conflict with external system',
  record: 'Record',
  fileAndDocuments: 'File and documents',
  internal: 'Internal',
  internalTemplate: 'Internal template',
  splash: 'splash',
  driver: 'Driver',
  vehicle: 'Vehicle',
  delivery: 'Delivery',
  pickup: 'Pickup',
  order: 'Order',
  license: 'Licenses',
  audit: 'Audit',
  exception: 'Exception',
  general: 'General',
  shipmentStatistics: 'Order statistics',
  companyShipmentStatistics: 'Courier order statistics',
  userStatistics: 'User statistics',
  companyScoreStatistics: 'Courier score statistics',
  site: 'Site',
  page: 'Page',
  siteGenerator: 'Site generator',
  statistics: 'Statistics',
  operation: 'Operration',
  parameter: 'Parameter',
  driverActivity: 'Driver activity',
  layout: 'Layout',
  template: 'Template',
  operationEditor: 'Operation editor',
  operationAnonymous: 'Operation anonymous',
  limitLicense: 'Limit license',
  permissionLicense: 'Permission license',
  tariffAuction: 'Auction',
  carTariff: 'Car tariff',
  employeeTariff: 'Employee tariff',
  trafficPlanTariff: 'traffic plan tariff',
  itemTariff: 'Item tariff',
  auctiontariff: 'Auction tariff',
  specialTariff: 'special tariff',
  companyTarrif: 'Courier tariff',
  companyShipmentSupport: 'Courier order support',
  faq: 'Faq',
  contact: 'Contact',
  messenger: 'Messenger',
  decision: 'Decision',
  email: 'Email',
  sms: 'Sms',
  permission: 'Permission',
  ticket: 'Ticket',
  transport: 'Transport',
  speedDrivers: 'Speed Drivers',
  shipmentTemplate: 'Order template',
  shipmentDraft: 'Order draft',
  codeGenerator: 'Code generator',
  System: 'system',
  settings: 'Settings',
  appVersion: 'App Version',
  webView: 'WebView',
  webServices: 'WebServices',
  urlShortened: 'Url Shortened',
  url: 'Url',
  registerOrder: 'Register order',
  registerTemplate: 'Register template',
  limit: 'Limit',
  generalLimits: 'General limits',
  webService: 'Web service',
  temporaryShipment: 'Temporary order',
  price: 'Price',
  post: 'Post',
  comment: 'Comment',
  suspend: 'Suspend',
  loadCategory: 'Load category',
  pioCategory: 'Point of interest category',
  poi: 'Point of interest',
  soil: 'Soil',
  carManage: 'Car Manage',
  content: 'Content',
  blog: 'Blog',
  tag: 'Tag',
  respond: 'Respond',
  materialTariff: 'Material tariff',
  trashTariff: 'Trash tariff',
  freightTariff: 'Freight tariff',
  furnitureTariff: 'Furniture tariff',
  cargoTariff: 'Cargo tariff',
  attachment: 'attachment',
  container: 'container',
  bucket: 'bucket',
  events: 'events',
  map: 'Map',
  financialAccount: 'Account',
  commercialBanking: 'Commercial banking',
  trashCar: 'Trash car',
  trashCarTariff: 'Trash car tariff',
  freightCarTariff: 'Freight car tariff',
  packageTypes: 'Package Types',
  bill: 'Bill',
  bankCredit: 'Bank credit',
  wallet: 'Wallet',
  trash: 'Trash',
  Trash: 'Trash',
  freight: 'Freight',
  Freight: 'Freight',
  Material: 'Material',
  supported: 'Supported',
  supportedOrder: 'Supported order',
  supportedCourier: 'Supported courier',
  external: 'External system',
  baraneh: 'Baraneh',
  Settlement: 'Settlement',
  SupportedRangeType: 'range and type',
  credential: 'Credential',
  baadpa: 'Baadpa',
  blackList: 'Black list',
  CourierBlackList: 'Courier black list',
  DriverBlackList: 'Driver black list',
  updateLegal: 'Update legal information',
  legal: 'Legal',
  UserLegal: 'Legal user',
  batchOrder: 'Batch order',
  addon: 'Addon',
  loadCondition: 'Load condition',
  tutorial: 'Tutorial',
  billOfLading: 'Bill Of Lading',
  ReceivedReport: 'Received Report',
  ProcessingReport: 'Processing Report',
  PaymentQueueReport: 'Payment Queue Report',
  PaidReport: 'Paid Report',
  openBankingPayment: 'Open Banking Payment',
  shift: 'Shift'
}
